export default function getDateRangeOptionNormalized(option) {
    if (option && option.value && Array.isArray(option.value)) {
        return {
            ...option,
            value: option.value.map((date) => new Date(date)),
        };
    }
    return option;
}
